import { State } from "components/pipeline-components/classes/state-machine/state";
import { StatesMachine } from "components/pipeline-components/classes/state-machine/state-machine";
import { SaqueComplementarPipeline } from "components/pipeline-components/classes/parts/higienizacao/SaqueComplementarPipeline";
import { DiagnosticPanel } from "./DiagnosticPanel";

export function SaqueComplementarEditor({
  isDisabled,
  saqueValue,
  updatePipelineData,
  selectedStateId,
  pipelineData,
  diagnosticUpdatePipelineData
}: {
  isDisabled: boolean;
  saqueValue: {
    banco: string;
    idConvenio: string;
    tipoCartao: string;
    codigoTabela: string;
  };
  updatePipelineData: (
    updater: (draft: StatesMachine) => StatesMachine | void
  ) => void;
  selectedStateId?: number;
  pipelineData?: StatesMachine;
  diagnosticUpdatePipelineData?: (
    updater: (draft: StatesMachine) => StatesMachine | void
  ) => void;
}) {
  return (
    <>
      <SaqueComplementarPipeline
        isDisabled={isDisabled}
        value={saqueValue.banco ? [saqueValue] : []}
        onChange={(newValue) =>
          updatePipelineData((draft) => {
            draft.addOperationState("SAQUE_COMPLEMENTAR");

            const executorStates = draft.states
              .filter(
                (state) =>
                  state.operation === "SAQUE_COMPLEMENTAR" &&
                  state.stateType === "EXECUTOR"
              )
              .sort((a, b) => a.id - b.id);

            const selectedValue = newValue?.[0];

            if (!selectedValue?.banco) {
              executorStates.forEach((state) => draft.removeState(state.id));
              return;
            }

            const existingState = executorStates[0];
            if (existingState) {
              existingState.banco = selectedValue.banco;
              existingState.codigoTabela = selectedValue.codigoTabela;
              existingState.idConvenio = selectedValue.idConvenio;
              existingState.tipoCartao = selectedValue.tipoCartao;
            } else {
              const newState = new State({
                id: StatesMachine.getNextStateIdFrom(draft.states),
                operation: "SAQUE_COMPLEMENTAR",
                stateType: "EXECUTOR",
                banco: selectedValue.banco,
                codigoTabela: selectedValue.codigoTabela,
                idConvenio: selectedValue.idConvenio,
                tipoCartao: selectedValue.tipoCartao
              });
              draft.addState(newState);
            }

            executorStates
              .slice(1)
              .forEach((state) => draft.removeState(state.id));

            return;
          })
        }
      />
      {selectedStateId != null &&
        pipelineData &&
        diagnosticUpdatePipelineData && (
          <DiagnosticPanel
            selectedStateId={selectedStateId}
            pipelineData={pipelineData}
            operation="SAQUE_COMPLEMENTAR"
            updatePipelineData={diagnosticUpdatePipelineData}
          />
        )}
    </>
  );
}
